package com.htmlagent.site.i18n

// Generated from i18n/strings.json. Do not edit: edit the JSON and rebuild.

/** The texts of the brief area. */
interface BriefStrings {
    val title: String

    val subtitle: String

    val close: String

    fun stepName(id: String): String

    val next: String

    val generate: String

    val back: String

    val skipStep: String

    val writeMyself: String

    val undecided: String

    val commissionTitle: String

    val commissionLede: String

    val kindLabel: String

    val kindDefault: String

    fun kindName(id: String): String

    fun kindLine(id: String): String

    fun kindNote(id: String): String

    val whatLabel: String

    val whatPlaceholder: String

    val actionLabel: String

    fun actionName(id: String): String

    val referencesLabel: String

    val referencesHint: String

    val referencesPlaceholder: String

    val registerTitle: String

    val registerLede: String

    fun registerName(id: String): String

    fun registerLine(id: String): String

    fun budgetTitle(register: String): String

    val budgetAccents: String

    val budgetGestures: String

    val budgetMotion: String

    val budgetRadii: String

    val budgetDensity: String

    fun motionName(id: String): String

    fun densityName(id: String): String

    val ungraded: String

    val colourTitle: String

    val colourLede: String

    val accentLabel: String

    val pickerLabel: String

    val otherColours: String

    val accentScale: String

    val neutralScale: String

    fun onSolidLabel(detail: String): String

    fun onSurfaceLabel(detail: String): String

    fun hueNote(detail: String): String

    fun hueSuspect(detail: String): String

    val greyNote: String

    fun swatchName(id: String): String

    fun contrastPass(id: String): String

    val formTitle: String

    fun formLede(register: String): String

    val typeLabel: String

    val sampleDisplay: String

    val sampleBody: String

    val imageryLabel: String

    fun imageryName(id: String): String

    fun imageryLine(id: String): String

    val treatmentLabel: String

    fun treatmentName(id: String): String

    val gestureLabel: String

    fun gestureChosen(detail: String): String

    fun gestureName(id: String): String

    fun gestureKind(id: String): String

    val gestureNoteOne: String

    val gestureNoteTwo: String

    val panelTitle: String

    val panelShow: String

    val panelHide: String

    val lblSummary: String

    val lblStyle: String

    val lblStructure: String

    val lblGesture: String

    val lblReferences: String

    val lblNotes: String

    val kKind: String

    val kRegister: String

    val kType: String

    val kAccent: String

    val kNeutral: String

    val kText: String

    val kMotion: String

    val kImagery: String

    fun accentCount(n: Int): String

    fun gestureBudget(n: Int): String

    fun radiusCount(n: Int): String

    fun densityPhrase(detail: String): String

    fun motionPhrase(detail: String): String

    fun summarySingleAction(action: String): String

    fun summaryAction(action: String): String

    fun accentRule(hex: String): String

    fun neutralRule(detail: String): String

    fun typeRule(detail: String): String

    fun textRule(detail: String): String

    fun imageryRule(detail: String): String

    fun imageryPrompt(id: String): String

    fun treatmentPrompt(id: String): String

    fun gestureRule(detail: String): String

    val gestureNone: String

    val promptNotes: String

    val sectionsLanding: List<String>

    val sectionsMenu: List<String>

    val sectionsEvent: List<String>

    val sectionsPortfolio: List<String>

    val sectionsProfile: List<String>

    val sectionsWaiting: List<String>

    val typeDisplayRole: String

    val typeBodyRole: String

    val inkWhite: String

    val inkAccent: String

    fun chromaPhrase(detail: String): String

    fun styleHue(detail: String): String

    val promptDecided: String

    val typeLoad: String

    val typeFallback: String

    val promptDirectionSettled: String

    val promptPresence: String
}

/** The brief area in Spanish. */
internal object SpanishBriefStrings : BriefStrings {
    override val title: String = "Antes de escribir la página"

    override val subtitle: String = "Cuatro decisiones que cambian la página entera. Ninguna es obligatoria: lo que no contestes lo decide el agente."

    override val close: String = "Cerrar"

    override fun stepName(id: String): String =
        mapOf(
        "commission" to "Encargo",
        "register" to "Registro",
        "colour" to "Color",
        "form" to "Forma",
        )[id] ?: humanizeSectionId(id)

    override val next: String = "Siguiente"

    override val generate: String = "Generar la página"

    override val back: String = "Atrás"

    override val skipStep: String = "Saltar este paso"

    override val writeMyself: String = "Prefiero escribirlo yo"

    override val undecided: String = "lo decide el agente"

    override val commissionTitle: String = "El encargo"

    override val commissionLede: String = "Qué clase de página es, de qué va y qué tiene que hacer quien entre."

    override val kindLabel: String = "Qué clase de página"

    override val kindDefault: String = "por defecto"

    override fun kindName(id: String): String =
        mapOf(
        "landing" to "Landing",
        "menu" to "Carta",
        "event" to "Evento",
        "portfolio" to "Portafolio",
        "profile" to "Perfil",
        "waiting" to "Página de espera",
        )[id] ?: humanizeSectionId(id)

    override fun kindLine(id: String): String =
        mapOf(
        "landing" to "Una promesa y una acción, repetida al final",
        "menu" to "El producto listado, para leer de pie",
        "event" to "Cinco datos colgando de una fecha",
        "portfolio" to "El trabajo primero, el texto después",
        "profile" to "Una persona o un negocio, en una pantalla larga",
        "waiting" to "Una pantalla y un solo dato pedido",
        )[id] ?: humanizeSectionId(id)

    override fun kindNote(id: String): String =
        mapOf(
        "landing" to "Una landing tiene una sola acción. Las demás bajan a texto y la página entera se ordena alrededor de la que elijas.",
        "menu" to "Una carta se lee en el móvil y de pie. Mandan la legibilidad y el orden, no la escenografía.",
        "event" to "Un evento vive de cinco datos: qué, cuándo, dónde, cuánto y cómo apuntarse. Si falta uno, la página no sirve.",
        "portfolio" to "Un portafolio se ordena por el trabajo, no por argumentos. La acción llega al final, cuando ya te han visto.",
        "profile" to "Un perfil cabe en una pantalla larga. Todo lo que no diga quién eres sobra.",
        "waiting" to "Una página de espera es una sola pantalla. Un dato pedido, uno solo, y nada que desplazar.",
        )[id] ?: humanizeSectionId(id)

    override val whatLabel: String = "Qué es y para quién"

    override val whatPlaceholder: String = "Cafetería de barrio, café de origen colombiano, clientela del vecindario…"

    override val actionLabel: String = "Qué tiene que hacer quien entre"

    override fun actionName(id: String): String =
        mapOf(
        "visit" to "Visitar el local",
        "book" to "Reservar",
        "buy" to "Comprar en línea",
        "write" to "Escribir",
        "subscribe" to "Dejar el correo",
        )[id] ?: humanizeSectionId(id)

    override val referencesLabel: String = "Referencias visuales"

    override val referencesHint: String = "opcional, y es lo que más afina"

    override val referencesPlaceholder: String = "Pega una o dos direcciones de sitios que te gusten"

    override val registerTitle: String = "¿Qué debería sentirse en tres segundos?"

    override val registerLede: String = "Esta es la decisión que manda: fija cuánto puede acumular la página."

    override fun registerName(id: String): String =
        mapOf(
        "editorial" to "Editorial",
        "technical" to "Técnico",
        "warm" to "Cálido",
        "institutional" to "Institucional",
        "expressive" to "Expresivo",
        "material" to "Material",
        )[id] ?: humanizeSectionId(id)

    override fun registerLine(id: String): String =
        mapOf(
        "editorial" to "La letra al mando, mucho aire, imágenes pocas y grandes",
        "technical" to "Denso y ordenado, monoespaciada donde se gana, cero adorno",
        "warm" to "Tierras y cremas, formas blandas, cercanía",
        "institutional" to "Contenido, alto contraste, rejilla visible",
        "expressive" to "Color saturado, escala agresiva, asimetría",
        "material" to "Superficie, profundidad, color pleno, elevación",
        )[id] ?: humanizeSectionId(id)

    override fun budgetTitle(register: String): String = "Presupuesto de $register"

    override val budgetAccents: String = "Acentos"

    override val budgetGestures: String = "Gestos"

    override val budgetMotion: String = "Movimiento"

    override val budgetRadii: String = "Radios"

    override val budgetDensity: String = "Densidad"

    override fun motionName(id: String): String =
        mapOf(
        "none" to "ninguno",
        "low" to "bajo",
        "medium" to "medio",
        "high" to "alto",
        )[id] ?: humanizeSectionId(id)

    override fun densityName(id: String): String =
        mapOf(
        "airy" to "aireada",
        "medium" to "media",
        "dense" to "densa",
        )[id] ?: humanizeSectionId(id)

    override val ungraded: String = "Nada de esto se gradúa nunca: contraste del texto, foco visible, movimiento reducido y área táctil de 44 px."

    override val colourTitle: String = "El acento sale de la materia del encargo"

    override val colourLede: String = "Elige uno y la escala completa se deriva de él. Los neutros también."

    override val accentLabel: String = "Acento"

    override val pickerLabel: String = "Elige el acento"

    override val otherColours: String = "O parte de otro"

    override val accentScale: String = "Escala del acento"

    override val neutralScale: String = "Neutros, inclinados hacia el acento"

    override fun onSolidLabel(detail: String): String = "Texto sobre el sólido · $detail"

    override fun onSurfaceLabel(detail: String): String = "Texto sobre superficie · $detail"

    override fun hueNote(detail: String): String = "Tono $detail. Toda la escala mantiene este tono."

    override fun hueSuspect(detail: String): String = "Tono $detail — está en la franja que hay que poder justificar. Si no sale de la materia del encargo, gírala."

    override val greyNote: String = "Un gris que se inclina un poco hacia el acento parece elegido; #808080 parece una plantilla."

    override fun swatchName(id: String): String =
        mapOf(
        "#8A4B2A" to "Café tostado",
        "#B85235" to "Terracota",
        "#5E6B3A" to "Verde oliva",
        "#1E7A82" to "Turquesa",
        "#4F5BD5" to "Índigo",
        "#7A3B6B" to "Ciruela",
        )[id] ?: humanizeSectionId(id)

    override fun contrastPass(id: String): String =
        mapOf(
        "body" to "AA cuerpo",
        "display" to "AA sólo display",
        "fail" to "no llega",
        )[id] ?: humanizeSectionId(id)

    override val formTitle: String = "La letra, la imagen y el gesto"

    override fun formLede(register: String): String = "Las parejas salen de $register. El gesto es la idea que esta página tiene y otras no."

    override val typeLabel: String = "Tipografía"

    override val sampleDisplay: String = "Café de origen"

    override val sampleBody: String = "Tostamos cada lunes lo que se muele esa semana."

    override val imageryLabel: String = "De dónde salen los visuales"

    override fun imageryName(id: String): String =
        mapOf(
        "built" to "Construidos",
        "photography" to "Fotografía",
        "none" to "Sin imágenes",
        )[id] ?: humanizeSectionId(id)

    override fun imageryLine(id: String): String =
        mapOf(
        "built" to "Gradientes, geometría y SVG. Ni una petición de red y nunca sale algo que no viene a cuento",
        "photography" to "Buscada, no recordada: viene verificada y del tema, con su crédito en el pie",
        "none" to "Sólo letra y superficie. Es la vía más rápida a una página plana: elígela a sabiendas",
        )[id] ?: humanizeSectionId(id)

    override val treatmentLabel: String = "Tratamiento"

    override fun treatmentName(id: String): String =
        mapOf(
        "full-colour" to "A color",
        "grey-to-colour" to "Gris que vira al pasar el ratón",
        "veiled" to "Con velo para el texto encima",
        )[id] ?: humanizeSectionId(id)

    override val gestureLabel: String = "El gesto"

    override fun gestureChosen(detail: String): String = "$detail elegidos"

    override fun gestureName(id: String): String =
        mapOf(
        "broken-grid" to "Rejilla que se rompe en una sección",
        "giant-figures" to "Cifras enormes como elemento gráfico",
        "colour-bleed" to "Bloque de color a sangre",
        "overlap" to "Dos elementos solapados",
        "build-on-entry" to "Una figura que se construye al entrar",
        "cursor-scene" to "Una escena 3D que sigue al cursor",
        )[id] ?: humanizeSectionId(id)

    override fun gestureKind(id: String): String =
        mapOf(
        "composition" to "composición",
        "behaviour" to "comportamiento",
        )[id] ?: humanizeSectionId(id)

    override val gestureNoteOne: String = "Presupuesto de uno: o de composición o de comportamiento, no los dos."

    override val gestureNoteTwo: String = "Presupuesto de dos, y de clases distintas: uno de composición y uno de comportamiento."

    override val panelTitle: String = "Lo que recibe el agente"

    override val panelShow: String = "Ver lo que se le manda al agente"

    override val panelHide: String = "Ocultar lo que se le manda al agente"

    override val lblSummary: String = "Resumen"

    override val lblStyle: String = "Estilo"

    override val lblStructure: String = "Estructura"

    override val lblGesture: String = "Gesto"

    override val lblReferences: String = "Referencias"

    override val lblNotes: String = "Notas"

    override val kKind: String = "tipo"

    override val kRegister: String = "registro"

    override val kType: String = "tipografía"

    override val kAccent: String = "acento"

    override val kNeutral: String = "neutros"

    override val kText: String = "texto"

    override val kMotion: String = "movimiento"

    override val kImagery: String = "imagen"

    override fun accentCount(n: Int): String = when (n) {
        1 -> "1 acento"
        else -> "$n acentos"
    }

    override fun gestureBudget(n: Int): String = when (n) {
        1 -> "1 gesto"
        else -> "$n gestos"
    }

    override fun radiusCount(n: Int): String = when (n) {
        1 -> "1 radio"
        else -> "$n radios"
    }

    override fun densityPhrase(detail: String): String = "densidad $detail"

    override fun motionPhrase(detail: String): String = "movimiento $detail"

    override fun summarySingleAction(action: String): String = "Una sola acción: $action."

    override fun summaryAction(action: String): String = "Acción principal: $action."

    override fun accentRule(hex: String): String = "$hex — sólo en la acción principal, nunca en texto estático"

    override fun neutralRule(detail: String): String = "derivados del mismo tono, $detail"

    override fun typeRule(detail: String): String = "$detail"

    override fun textRule(detail: String): String = "$detail — a plena intensidad, sin opacidad"

    override fun imageryRule(detail: String): String = "$detail"

    override fun imageryPrompt(id: String): String =
        mapOf(
        "built" to "construidos con gradientes, geometría y SVG; ninguna petición a un banco de imágenes",
        "photography" to "fotografía obtenida con buscar_imagen, con el crédito en el pie; nunca un identificador escrito de memoria",
        "none" to "sin fotografías; la presencia sale de la escala, la superficie y la profundidad",
        )[id] ?: humanizeSectionId(id)

    override fun treatmentPrompt(id: String): String =
        mapOf(
        "full-colour" to "a color, sin filtro",
        "grey-to-colour" to "en gris, que vira a color al pasar el ratón en 700 ms",
        "veiled" to "con una capa encima calibrada para que el texto llegue a 4.5:1 sobre esa capa sola contra blanco puro",
        )[id] ?: humanizeSectionId(id)

    override fun gestureRule(detail: String): String = "$detail"

    override val gestureNone: String = "sin gesto decidido"

    override val promptNotes: String = "Página única, sin dependencias ni paso de compilación. Contraste, foco visible, movimiento reducido y área táctil no se negocian. Los datos que no te he dado —dirección, horario, precios— van entre corchetes."

    override val sectionsLanding: List<String> = listOf(
        "Portada — la promesa y la acción",
        "Por qué este y no otro",
        "Lo que se ofrece",
        "Prueba: quién ya lo usa",
        "Cierre — la misma acción",
    )

    override val sectionsMenu: List<String> = listOf(
        "Cabecera — el sitio y sus horas",
        "El producto principal",
        "Para acompañar",
        "Para llevar",
        "Dónde estamos",
    )

    override val sectionsEvent: List<String> = listOf(
        "Portada — qué, cuándo y dónde",
        "El programa",
        "Quién lo lleva",
        "Cómo llegar",
        "Plazas y precio",
    )

    override val sectionsPortfolio: List<String> = listOf(
        "Portada — quién y qué",
        "Selección de trabajos",
        "Un encargo en detalle",
        "Cómo trabajo",
        "Contacto",
    )

    override val sectionsProfile: List<String> = listOf(
        "Portada — nombre y oficio",
        "A qué me dedico",
        "Trayectoria",
        "Dónde encontrarme",
        "Contacto",
    )

    override val sectionsWaiting: List<String> = listOf(
        "Una sola pantalla — la promesa y el campo",
    )

    override val typeDisplayRole: String = "para display"

    override val typeBodyRole: String = "para texto"

    override val inkWhite: String = "blanco"

    override val inkAccent: String = "la tinta del acento"

    override fun chromaPhrase(detail: String): String = "croma $detail"

    override fun styleHue(detail: String): String = "el acento vive en el tono $detail y toda la escala lo mantiene"

    override val promptDecided: String = "Lo que sigue ya está decidido: aplícalo, no lo vuelvas a elegir. Lo que no aparezca aquí lo decides tú."

    override val typeLoad: String = "cárgalas desde fonts.googleapis.com con display=swap y sólo los pesos que uses; la pila de respaldo no basta"

    override val typeFallback: String = "respaldo"

    override val promptDirectionSettled: String = "La dirección visual viene decidida entera: registro, tipografía, acento y gesto. No la vuelvas a elegir ni cargues instrucciones para elegirla — aplícala. Y al contarlo, di lo que aplicas, no lo que elegiste."

    override val promptPresence: String = "La página tiene que tener presencia: un elemento dominante en la primera pantalla, display a 4–6 veces el cuerpo, al menos un visual no textual con peso y más de un plano. Una página correcta y plana es la otra forma de fallar, y la más fácil."
}

/** The brief area in English. */
internal object EnglishBriefStrings : BriefStrings {
    override val title: String = "Before writing the page"

    override val subtitle: String = "Four decisions that change the whole page. None is required: whatever you leave alone, the agent decides."

    override val close: String = "Close"

    override fun stepName(id: String): String =
        mapOf(
        "commission" to "Commission",
        "register" to "Register",
        "colour" to "Colour",
        "form" to "Form",
        )[id] ?: humanizeSectionId(id)

    override val next: String = "Next"

    override val generate: String = "Generate the page"

    override val back: String = "Back"

    override val skipStep: String = "Skip this step"

    override val writeMyself: String = "I would rather write it myself"

    override val undecided: String = "the agent decides"

    override val commissionTitle: String = "The commission"

    override val commissionLede: String = "What kind of page it is, what it is about and what a visitor has to do."

    override val kindLabel: String = "What kind of page"

    override val kindDefault: String = "default"

    override fun kindName(id: String): String =
        mapOf(
        "landing" to "Landing",
        "menu" to "Menu",
        "event" to "Event",
        "portfolio" to "Portfolio",
        "profile" to "Profile",
        "waiting" to "Waiting page",
        )[id] ?: humanizeSectionId(id)

    override fun kindLine(id: String): String =
        mapOf(
        "landing" to "One promise and one action, repeated at the end",
        "menu" to "The product listed, to be read standing up",
        "event" to "Five facts hanging off a date",
        "portfolio" to "The work first, the words after",
        "profile" to "A person or a business, in one long screen",
        "waiting" to "One screen and a single thing asked for",
        )[id] ?: humanizeSectionId(id)

    override fun kindNote(id: String): String =
        mapOf(
        "landing" to "A landing page has one action. The rest drop to text and the whole page is ordered around the one you pick.",
        "menu" to "A menu is read on a phone, standing up. Legibility and order rule, not scenery.",
        "event" to "An event lives off five facts: what, when, where, how much and how to sign up. Miss one and the page is useless.",
        "portfolio" to "A portfolio is ordered by the work, not by arguments. The action comes last, once they have seen you.",
        "profile" to "A profile fits in one long screen. Anything that does not say who you are is surplus.",
        "waiting" to "A waiting page is one screen. One thing asked for, and nothing to scroll.",
        )[id] ?: humanizeSectionId(id)

    override val whatLabel: String = "What it is and who it is for"

    override val whatPlaceholder: String = "Neighbourhood café, single-origin Colombian coffee, local regulars…"

    override val actionLabel: String = "What a visitor has to do"

    override fun actionName(id: String): String =
        mapOf(
        "visit" to "Visit in person",
        "book" to "Book",
        "buy" to "Buy online",
        "write" to "Get in touch",
        "subscribe" to "Leave an email",
        )[id] ?: humanizeSectionId(id)

    override val referencesLabel: String = "Visual references"

    override val referencesHint: String = "optional, and it is what sharpens most"

    override val referencesPlaceholder: String = "Paste one or two addresses of sites you like"

    override val registerTitle: String = "What should it feel like in three seconds?"

    override val registerLede: String = "This is the decision that rules: it sets how much the page may accumulate."

    override fun registerName(id: String): String =
        mapOf(
        "editorial" to "Editorial",
        "technical" to "Technical",
        "warm" to "Warm",
        "institutional" to "Institutional",
        "expressive" to "Expressive",
        "material" to "Material",
        )[id] ?: humanizeSectionId(id)

    override fun registerLine(id: String): String =
        mapOf(
        "editorial" to "Type in the lead, plenty of air, few and large images",
        "technical" to "Dense and ordered, monospace where it earns it, zero ornament",
        "warm" to "Earth tones and creams, soft shapes, closeness",
        "institutional" to "Restrained, high contrast, visible grid",
        "expressive" to "Saturated colour, aggressive scale, asymmetry",
        "material" to "Surface, depth, full colour, elevation",
        )[id] ?: humanizeSectionId(id)

    override fun budgetTitle(register: String): String = "The $register budget"

    override val budgetAccents: String = "Accents"

    override val budgetGestures: String = "Gestures"

    override val budgetMotion: String = "Motion"

    override val budgetRadii: String = "Radii"

    override val budgetDensity: String = "Density"

    override fun motionName(id: String): String =
        mapOf(
        "none" to "none",
        "low" to "low",
        "medium" to "medium",
        "high" to "high",
        )[id] ?: humanizeSectionId(id)

    override fun densityName(id: String): String =
        mapOf(
        "airy" to "airy",
        "medium" to "medium",
        "dense" to "dense",
        )[id] ?: humanizeSectionId(id)

    override val ungraded: String = "None of this is ever graded: text contrast, visible focus, reduced motion and a 44 px touch target."

    override val colourTitle: String = "The accent comes from the matter of the commission"

    override val colourLede: String = "Pick one and the whole scale is derived from it. The neutrals too."

    override val accentLabel: String = "Accent"

    override val pickerLabel: String = "Pick the accent"

    override val otherColours: String = "Or start from another"

    override val accentScale: String = "The accent's scale"

    override val neutralScale: String = "Neutrals, leaning towards the accent"

    override fun onSolidLabel(detail: String): String = "Text on the solid · $detail"

    override fun onSurfaceLabel(detail: String): String = "Text on a surface · $detail"

    override fun hueNote(detail: String): String = "Hue $detail. The whole scale keeps this hue."

    override fun hueSuspect(detail: String): String = "Hue $detail — it sits in the band you have to be able to justify. If it does not come from the subject, turn it."

    override val greyNote: String = "A grey that leans slightly towards the accent looks chosen; #808080 looks like a template."

    override fun swatchName(id: String): String =
        mapOf(
        "#8A4B2A" to "Roasted coffee",
        "#B85235" to "Terracotta",
        "#5E6B3A" to "Olive",
        "#1E7A82" to "Turquoise",
        "#4F5BD5" to "Indigo",
        "#7A3B6B" to "Plum",
        )[id] ?: humanizeSectionId(id)

    override fun contrastPass(id: String): String =
        mapOf(
        "body" to "AA body",
        "display" to "AA display only",
        "fail" to "falls short",
        )[id] ?: humanizeSectionId(id)

    override val formTitle: String = "The type, the image and the gesture"

    override fun formLede(register: String): String = "The pairings come from $register. The gesture is the idea this page has and others do not."

    override val typeLabel: String = "Typeface"

    override val sampleDisplay: String = "Single origin"

    override val sampleBody: String = "We roast on Mondays what gets ground that week."

    override val imageryLabel: String = "Where the visuals come from"

    override fun imageryName(id: String): String =
        mapOf(
        "built" to "Built",
        "photography" to "Photography",
        "none" to "No images",
        )[id] ?: humanizeSectionId(id)

    override fun imageryLine(id: String): String =
        mapOf(
        "built" to "Gradients, geometry and SVG. Not one network request, and it never comes back off-topic",
        "photography" to "Searched, not remembered: it arrives verified and on subject, with its credit in the footer",
        "none" to "Type and surface only. It is the fastest route to a flat page: pick it knowingly",
        )[id] ?: humanizeSectionId(id)

    override val treatmentLabel: String = "Treatment"

    override fun treatmentName(id: String): String =
        mapOf(
        "full-colour" to "Full colour",
        "grey-to-colour" to "Grey turning to colour on hover",
        "veiled" to "Veiled, for text on top",
        )[id] ?: humanizeSectionId(id)

    override val gestureLabel: String = "The gesture"

    override fun gestureChosen(detail: String): String = "$detail chosen"

    override fun gestureName(id: String): String =
        mapOf(
        "broken-grid" to "A grid that breaks in one section",
        "giant-figures" to "Enormous figures as a graphic element",
        "colour-bleed" to "A full-bleed block of colour",
        "overlap" to "Two elements overlapping",
        "build-on-entry" to "A figure that builds itself on entry",
        "cursor-scene" to "A 3D scene that follows the cursor",
        )[id] ?: humanizeSectionId(id)

    override fun gestureKind(id: String): String =
        mapOf(
        "composition" to "composition",
        "behaviour" to "behaviour",
        )[id] ?: humanizeSectionId(id)

    override val gestureNoteOne: String = "A budget of one: composition or behaviour, not both."

    override val gestureNoteTwo: String = "A budget of two, of different kinds: one of composition and one of behaviour."

    override val panelTitle: String = "What the agent receives"

    override val panelShow: String = "See what is sent to the agent"

    override val panelHide: String = "Hide what is sent to the agent"

    override val lblSummary: String = "Summary"

    override val lblStyle: String = "Style"

    override val lblStructure: String = "Structure"

    override val lblGesture: String = "Gesture"

    override val lblReferences: String = "References"

    override val lblNotes: String = "Notes"

    override val kKind: String = "kind"

    override val kRegister: String = "register"

    override val kType: String = "typeface"

    override val kAccent: String = "accent"

    override val kNeutral: String = "neutrals"

    override val kText: String = "text"

    override val kMotion: String = "motion"

    override val kImagery: String = "imagery"

    override fun accentCount(n: Int): String = when (n) {
        1 -> "1 accent"
        else -> "$n accents"
    }

    override fun gestureBudget(n: Int): String = when (n) {
        1 -> "1 gesture"
        else -> "$n gestures"
    }

    override fun radiusCount(n: Int): String = when (n) {
        1 -> "1 radius"
        else -> "$n radii"
    }

    override fun densityPhrase(detail: String): String = "$detail density"

    override fun motionPhrase(detail: String): String = "$detail motion"

    override fun summarySingleAction(action: String): String = "One action only: $action."

    override fun summaryAction(action: String): String = "Main action: $action."

    override fun accentRule(hex: String): String = "$hex — on the main action only, never on static text"

    override fun neutralRule(detail: String): String = "derived from the same hue, $detail"

    override fun typeRule(detail: String): String = "$detail"

    override fun textRule(detail: String): String = "$detail — at full strength, no opacity"

    override fun imageryRule(detail: String): String = "$detail"

    override fun imageryPrompt(id: String): String =
        mapOf(
        "built" to "built from gradients, geometry and SVG; no request to any image bank",
        "photography" to "photography obtained with buscar_imagen, credited in the footer; never an identifier written from memory",
        "none" to "no photographs; presence comes from scale, surface and depth",
        )[id] ?: humanizeSectionId(id)

    override fun treatmentPrompt(id: String): String =
        mapOf(
        "full-colour" to "in full colour, unfiltered",
        "grey-to-colour" to "greyscale, turning to colour on hover over 700 ms",
        "veiled" to "with a layer on top calibrated so the text reaches 4.5:1 against that layer alone over pure white",
        )[id] ?: humanizeSectionId(id)

    override fun gestureRule(detail: String): String = "$detail"

    override val gestureNone: String = "no gesture decided"

    override val promptNotes: String = "A single page, no dependencies and no build step. Contrast, visible focus, reduced motion and touch target size are not negotiable. Facts I have not given you — address, hours, prices — go in brackets."

    override val sectionsLanding: List<String> = listOf(
        "Cover — the promise and the action",
        "Why this one and not another",
        "What is on offer",
        "Proof: who already uses it",
        "Close — the same action",
    )

    override val sectionsMenu: List<String> = listOf(
        "Header — the place and its hours",
        "The main product",
        "To go alongside",
        "To take away",
        "Where we are",
    )

    override val sectionsEvent: List<String> = listOf(
        "Cover — what, when and where",
        "The programme",
        "Who runs it",
        "How to get there",
        "Places and price",
    )

    override val sectionsPortfolio: List<String> = listOf(
        "Cover — who and what",
        "Selected work",
        "One commission in detail",
        "How I work",
        "Contact",
    )

    override val sectionsProfile: List<String> = listOf(
        "Cover — name and trade",
        "What I do",
        "Track record",
        "Where to find me",
        "Contact",
    )

    override val sectionsWaiting: List<String> = listOf(
        "A single screen — the promise and the field",
    )

    override val typeDisplayRole: String = "for display"

    override val typeBodyRole: String = "for body"

    override val inkWhite: String = "white"

    override val inkAccent: String = "the accent's own ink"

    override fun chromaPhrase(detail: String): String = "chroma $detail"

    override fun styleHue(detail: String): String = "the accent lives at hue $detail and the whole scale keeps it"

    override val promptDecided: String = "What follows is already decided: apply it, do not choose it again. Anything not listed here is yours to decide."

    override val typeLoad: String = "load them from fonts.googleapis.com with display=swap and only the weights you use; the fallback stack is not enough"

    override val typeFallback: String = "fallback"

    override val promptDirectionSettled: String = "The visual direction arrives fully decided: register, typeface, accent and gesture. Do not choose it again, and do not load instructions for choosing it — apply it. And when you report it, say what you are applying, not what you chose."

    override val promptPresence: String = "The page has to have presence: a dominant element in the first screen, display at 4–6 times the body, at least one non-text element with real weight, and more than one plane. A correct, flat page is the other way to fail, and the easier one."
}
